'use client';

import { useEffect, useState } from 'react';

/**
 * Хук, который возвращает статус, что вкладка браузера активна
 */
export const useDocumentVisibility = () => {
  const [isDocumentVisible, setDocumentVisible] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const compute = () => {
      const isVisible =
        document.visibilityState === 'visible' && document.hasFocus();
      setDocumentVisible(isVisible);
    };

    compute();

    document.addEventListener('visibilitychange', compute);
    window.addEventListener('focus', compute);
    window.addEventListener('blur', compute);
    window.addEventListener('pageshow', compute);
    window.addEventListener('pagehide', compute);

    const t = setTimeout(() => {
      setIsMounted(true);
    }, 500);

    return () => {
      clearTimeout(t);
      document.removeEventListener('visibilitychange', compute);
      window.removeEventListener('focus', compute);
      window.removeEventListener('blur', compute);
      window.removeEventListener('pageshow', compute);
      window.removeEventListener('pagehide', compute);
    };
  }, []);

  return {
    isDocumentVisible,
    isMounted
  };
};
